/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateBorrowerRealEstateAddressDto } from './CreateBorrowerRealEstateAddressDto';
import {
    CreateBorrowerRealEstateAddressDtoFromJSON,
    CreateBorrowerRealEstateAddressDtoFromJSONTyped,
    CreateBorrowerRealEstateAddressDtoToJSON,
    CreateBorrowerRealEstateAddressDtoToJSONTyped,
} from './CreateBorrowerRealEstateAddressDto';
import type { PropertyTypeEnum } from './PropertyTypeEnum';
import {
    PropertyTypeEnumFromJSON,
    PropertyTypeEnumFromJSONTyped,
    PropertyTypeEnumToJSON,
    PropertyTypeEnumToJSONTyped,
} from './PropertyTypeEnum';

/**
 * Simplified command to create a real estate property in the borrower context.
 * Only borrowerProjectId and address are required. Area, roomCount and propertyType
 * are optional — the backend will compute them if not provided.
 * 
 * @export
 * @interface CreateBorrowerRealEstateCommand
 */
export interface CreateBorrowerRealEstateCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateBorrowerRealEstateCommand
     */
    borrowerProjectId: string;
    /**
     * 
     * @type {number}
     * @memberof CreateBorrowerRealEstateCommand
     */
    area?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateBorrowerRealEstateCommand
     */
    roomCount?: number | null;
    /**
     * 
     * @type {PropertyTypeEnum}
     * @memberof CreateBorrowerRealEstateCommand
     */
    propertyType?: PropertyTypeEnum;
    /**
     * 
     * @type {CreateBorrowerRealEstateAddressDto}
     * @memberof CreateBorrowerRealEstateCommand
     */
    address: CreateBorrowerRealEstateAddressDto;
}



/**
 * Check if a given object implements the CreateBorrowerRealEstateCommand interface.
 */
export function instanceOfCreateBorrowerRealEstateCommand(value: object): value is CreateBorrowerRealEstateCommand {
    if (!('borrowerProjectId' in value) || value['borrowerProjectId'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    return true;
}

export function CreateBorrowerRealEstateCommandFromJSON(json: any): CreateBorrowerRealEstateCommand {
    return CreateBorrowerRealEstateCommandFromJSONTyped(json, false);
}

export function CreateBorrowerRealEstateCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateBorrowerRealEstateCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'borrowerProjectId': json['borrowerProjectId'],
        'area': json['area'] == null ? undefined : json['area'],
        'roomCount': json['roomCount'] == null ? undefined : json['roomCount'],
        'propertyType': json['propertyType'] == null ? undefined : PropertyTypeEnumFromJSON(json['propertyType']),
        'address': CreateBorrowerRealEstateAddressDtoFromJSON(json['address']),
    };
}

export function CreateBorrowerRealEstateCommandToJSON(json: any): CreateBorrowerRealEstateCommand {
    return CreateBorrowerRealEstateCommandToJSONTyped(json, false);
}

export function CreateBorrowerRealEstateCommandToJSONTyped(value?: CreateBorrowerRealEstateCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'borrowerProjectId': value['borrowerProjectId'],
        'area': value['area'],
        'roomCount': value['roomCount'],
        'propertyType': PropertyTypeEnumToJSON(value['propertyType']),
        'address': CreateBorrowerRealEstateAddressDtoToJSON(value['address']),
    };
}

